<button mat-stroked-button type="button" class="mb-3" (click)="openDialog()">
  <mat-icon>tune</mat-icon>
  {{ 'button.configureColumns' | translate }}
</button>
